<h2 class="dialog-title my-3">Overrides for "{{ attributeName }}"</h2>

<div class="dialog-content">
    @if (groupedOverrides.length) {
        <table mat-table [dataSource]="groupedOverrides" class="override-table w-100">
            <!-- Variation Name column -->
            <ng-container matColumnDef="variationName">
                <th mat-header-cell *matHeaderCellDef><b>Variation Name</b></th>
                <td mat-cell *matCellDef="let group">
                    <span class="variation-name-cell">
                        @if(doesGroupMatchFormValue(group)) {
                            <mat-icon class="match-icon">check_circle</mat-icon>
                        }
                        {{ group.variationLabel ?? group.variationTag }}
                    </span>
                </td>
            </ng-container>

            <!-- Value column — base value for Base Item, override value for others -->
            <ng-container matColumnDef="value">
                <th mat-header-cell *matHeaderCellDef><b>Value</b></th>
                <td mat-cell *matCellDef="let group">
                    @if (group.variationLabel === 'Base Item') {
                        {{ baseValue ?? 'Not Found' }}
                    } @else {
                        {{ group.overrides[0]?.value ?? 'Not Found' }}
                    }
                </td>
            </ng-container>

            <!-- Navigate button column — only for non-base variations -->
            <ng-container matColumnDef="navigate">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let group">
                    @if (group.variationLabel !== 'Base Item') {
                        <button mat-icon-button
                                class="navigate-btn"
                                matTooltip="Open variation in React Menu Builder"
                                (click)="navigateToVariation(group.variationTag)">
                            <mat-icon>open_in_new</mat-icon>
                        </button>
                    }
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="['variationName', 'value', 'navigate']"></tr>
            <tr mat-row *matRowDef="let group; columns: ['variationName', 'value', 'navigate'];"></tr>
        </table>
    } @else {
        <p class="text-center text-muted">No variation overrides found for this attribute.</p>
    }
</div>

<div mat-dialog-actions align="end">
    <button mat-button (click)="close()">Close</button>
</div>
